/**
 * 3D Tiles 타일셋에서 내용(glb 등)을 불러오지 못한 타일을 센다.
 *
 * 타일 하나가 실패하면(예: 서버에 파일이 없어 500) Cesium 의 `sampleHeightMostDetailed` 가 끝나지 않고,
 * 모듈의 DSM 스캔이 그것을 타임아웃 없이 기다려 "분석 영역 생성 중..." 이 영원히 돈다.
 * 그래서 시뮬레이션을 열기 전에 실패를 알 수 있도록 타일셋을 만들 때 미리 연결해 둔다.
 */
export interface TileFailureSource {
  tileFailed: {
    addEventListener: (listener: (error: { url?: string }) => void) => () => void
  }
}

/**
 * 실패한 타일을 센다. 같은 URL 은 한 번만 센다(재시도로 같은 실패가 여러 번 올 수 있다).
 * 시작할 때 `onChange(0)` 을 한 번 부르고, 새 실패가 생길 때마다 총 개수로 부른다. 반환 함수로 연결을 끊는다.
 */
export function watchTileFailures(tileset: TileFailureSource, onChange: (failedCount: number) => void): () => void {
  const failed = new Set<string>()
  let anonymous = 0
  onChange(0)
  return tileset.tileFailed.addEventListener((error) => {
    const key = error?.url ?? `#${++anonymous}`
    if (failed.has(key)) return
    failed.add(key)
    onChange(failed.size)
  })
}
